import React from "react";
import styles from "./skill-tab.module.css";
import Skill from "./skill";
import { v4 } from "uuid";
import { LOCALES } from "../../../../constants";

export default function SkillTab({ lang, savior, isTabActive, isBlossomed = false }) {
    return (
        <div className={`${styles["skill-tab"]} ${styles[isTabActive]}`}>
            {savior.skills.map((skill) => (
                <Skill
                    lang={lang}
                    charName={`${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]})`}
                    skill={skill}
                    isBlossomed={isBlossomed}
                    key={v4()}
                />
            ))}
        </div>
    );
}
